import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Quick Integration',
    description:
      'Set up and integrate a custom LLM chatbot into your app in minutes with a simple, step-by-step process – no coding skills needed.',
  },
  {
    icon: <ConstructionRoundedIcon />,
    title: 'Multi-Format Content',
    description:
      'Upload and utilize multiple text files, documents, URLs, and even voice clips (converted to text) to create a knowledge base for your bot effortlessly.',
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Custom API Actions',
    description:
      'Define tools such as Search, Create, Delete, and Get that allow the bot to perform real-time actions in your application, providing an interactive and functional user experience.',
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: 'Secure Frontend',
    description:
      'All tool actions are executed directly in the users browser, ensuring seamless integration while maintaining application security and managing authentication safely.',
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'User Engagement',
    description:
      'From navigating websites to creating support tickets, let your AI assistant handle interactions, boosting user satisfaction with fast and intelligent responses.',
  },
  {
    icon: <QueryStatsRoundedIcon />,
    title: 'Session Tracking',
    description:
      'SaasbotAI automatically tracks conversations with session IDs, allowing for continuous, context-aware discussions that enhance the experience for returning users.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Highlights
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
          Whether it's website navigation, user support, or automating actions in your application, 
          SaasbotAI gives you the tools to transform your user experience.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium',color: 'white'  }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
